var _path, _rect, _path2, _rect2, _rect3, _rect4, _rect5, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECT",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11,9.15a1,1,0,0,0-1-1H8v2H9v3H8v2h4v-2H11Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 4.85,
    width: 2,
    height: 2.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30,5H17.48A9,9,0,1,0,10,19a8.26,8.26,0,0,0,1-.06V30a1,1,0,0,0,1,1H30a1,1,0,0,0,1-1V6A1,1,0,0,0,30,5ZM3,10a7,7,0,1,1,7,7A7,7,0,0,1,3,10ZM29,29H13V18.47A9,9,0,0,0,19,10a8.81,8.81,0,0,0-.53-3H29Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 9,
    width: 7,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 12,
    width: 3,
    height: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 12,
    width: 3,
    height: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 15,
    width: 8,
    height: 2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "26 19 24 19 24 25 22 25 22 21 20 21 20 25 18 25 18 23 16 23 16 25 15 25 15 27 27 27 27 25 26 25 26 19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseUpdate);
export default __webpack_public_path__ + "static/media/courseUpdate.eb6ddf5845391f6ff20fcc30e1da51d6.svg";
export { ForwardRef as ReactComponent };